import { GALLERY_GROUP_LABELS, type GalleryGroupType, isGalleryGroupSlugType } from '@/defs/gallery'

export const getGalleryGroup = (slug: string, categories: Omit<GalleryGroupType, 'recs'>[]): GalleryGroupType => {
  const label = isGalleryGroupSlugType(slug)
    ? GALLERY_GROUP_LABELS[slug]
    : categories.find((c) => c.slug === slug) || { icon: 'diamond', label: 'Group' }

  return { ...label, recs: [], slug }
}
